import { assign, isArray } from '@atds-legacy/lang';
import { Record, Resource } from '@redge-media/fo-js-sdk';

const Category = Record.extend({
  constructor: function Category(attrs = [], opts = {}) {
    Record.call(this, assign(attrs, {
      subcategories: new Subcategories({
        id: attrs.id,
      }),
    }), opts);
  },

  getSubcategories() {
    if (this.subcategories.collection.isFetched) {
      return Promise.resolve(this.subcategories);
    }

    return this.subcategories.fetchAll();
  },
});

const Categories = Resource.extend({
  endpoint: '/items/categories',
  recordClass: Category,

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);

    if (isArray(data)) {
      return data.filter(({ name }) => name);
    }

    return data;
  },
});

const Subcategories = Resource.extend({
  constructor: function Subcategories({ id }) {
    this.endpoint = `items/categories?mainCategoryId=${id}`;
    Resource.call(this);
  },
});

export default Categories;
